function opendaysSliderMetric() {
    const slider = document.querySelector('.opendays__slider');

    if (!slider) {
        return;
    }

    const metric = slider.getAttribute('data-button-click-metrika');

    const nextBtn = slider.querySelector('.annonces-slider__next');
    const prevBtn = slider.querySelector('.slider__button--prev');

    const handleMetric = () => {
        if (metric) {
            new Function(metric)();
        }
    };

    if (nextBtn) {
        nextBtn.addEventListener('click', handleMetric);
    }

    if (prevBtn) {
        prevBtn.addEventListener('click', handleMetric);
    }
}

export { opendaysSliderMetric };